export const CONSTANTS = {
  SET_FIELD: '@set-new-password/SET_FIELD',
  SET_VALIDATION_ERROR: '@set-new-password/SET_VALIDATION_ERROR',
  SET_NEW_PASSWORD: '@set-new-password/SET_NEW_PASSWORD',
};

export default CONSTANTS;
